import React from 'react'
import Home from '../../home/Home';
import Services from '../../home/listings/service provider/Services';

const ServiceProviderView = () => {
  return (
        <>
        <Home />
        <Services />
        </>
  )
}

export default ServiceProviderView;
